.state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-3);
  padding: var(--space-9) var(--space-6);
  text-align: center;
}

.compact {
  padding: var(--space-6) var(--space-4);
  gap: var(--space-2);
}

.iconWrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: var(--radius-full);
  background-color: var(--color-surface-2);
  color: var(--color-text-muted);
}

.compact .iconWrap {
  width: 2.5rem;
  height: 2.5rem;
}

.errorIcon {
  background-color: var(--color-danger-soft);
  color: var(--color-danger);
}

.title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text);
}

.compact .title {
  font-size: var(--font-size-base);
}

.description {
  max-width: 44ch;
  font-size: var(--font-size-md);
  color: var(--color-text-muted);
}
